import React from 'react'
import { FormattedMessage } from 'react-intl'
import { DurationField } from 'components/forms'

export function Duration (props) {
  return (
    <DurationField
      {...props}
      bold
      short
      name='duration'
      labelComponent={(
        <FormattedMessage
          id='workouts.create.duration'
          defaultMessage='Duration'
        />
      )}
    />
  )
}

export default Duration
